export default {
  SESS_STORAGE_CUSTOMER_INFO_KEY: 'FORTIVA_CUSTOMER_INFO_FORM_DATA',
  SESS_STORAGE_APPLICATION_KEY: 'FORTIVA_APPLICATION',
  SESS_STORAGE_RELATIONSHIP_KEY: 'FORTIVA_RELATIONSHIP',
  UPDATE_OFFER_BUFFER_DELAY_MS: 2000,
};
